import type { ReworkCategory, Scan } from '@scans/types';
import { intersectionBy, pullAllBy } from 'lodash';
import { proxy } from 'valtio';

interface CheckboxSelectionState {
  checkedScans: Scan[];
  isSubmittingQaState: boolean;
}

export const checkboxSelectionState = proxy<CheckboxSelectionState>({
  checkedScans: [], // TODO I guess the whole thing could be even more simplified by just using scanIds and selectedReworkCategories as another state. Not whole scans.
  isSubmittingQaState: false,
});

export const searchedScanIdState = proxy<{ searchedScanId: string }>({
  searchedScanId: '',
});

export const setSearchedScanId = (id: string) => {
  searchedScanIdState.searchedScanId = id;
};

export const toggleReworkCategory = (reworkCategory: ReworkCategory) => {
  if (checkboxSelectionState.isSubmittingQaState) return;
  const { checkedScans } = checkboxSelectionState;
  const currentReworkCategories = checkedScans.flatMap((s) => s.reworkCategories);

  checkboxSelectionState.checkedScans = checkedScans.map((scan) => {
    const { reworkCategories } = scan;
    return {
      ...scan,
      reworkCategories: currentReworkCategories.includes(reworkCategory)
        ? reworkCategories.filter((item) => item !== reworkCategory)
        : reworkCategories.concat(reworkCategory),
    };
  });
};

export const toggleCheckedScans = (scans: Scan[]): void => {
  if (checkboxSelectionState.isSubmittingQaState) return;
  const allowedScans = scans.filter((s) => s.qaState !== 'SCAN_ONLY_DONE');
  if (allowedScans.length === 0) return;
  const { checkedScans } = checkboxSelectionState;
  const commonScans = intersectionBy(allowedScans, checkedScans, 'id');
  if (commonScans.length > 0) {
    checkboxSelectionState.checkedScans = pullAllBy(checkedScans, allowedScans, 'id');
  } else {
    checkboxSelectionState.checkedScans = [...checkedScans, ...allowedScans];
  }
};

export const uncheckAllScans = (): void => {
  if (checkboxSelectionState.isSubmittingQaState) return;
  checkboxSelectionState.checkedScans = [];
};

export const uncheckScans = (scanIds: string[]): void => {
  const submittedIds = new Set(scanIds);
  checkboxSelectionState.checkedScans = checkboxSelectionState.checkedScans.filter(
    (scan) => !submittedIds.has(scan.id),
  );
};
export const reduceCheckedScans = (scansIds: string[]): void => {
  checkboxSelectionState.checkedScans = scansIds
    .map((id) => checkboxSelectionState.checkedScans.find((scan) => scan.id === id))
    .filter(Boolean) as Scan[];
};

export const checkAllScans = (scans: Scan[]): void => {
  if (checkboxSelectionState.isSubmittingQaState) return;
  checkboxSelectionState.checkedScans = scans.filter((s) => s.qaState !== 'SCAN_ONLY_DONE');
};
